import Auth from './Auth/Auth'
import Footer from '../components/Footer/Footer'

import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './Routes'

const App = () => {
  return (
    <BrowserRouter>
      <Auth />
      <AppRoutes />
    </BrowserRouter>
  )
}

export default App
